import { faCheck, faClose, faRefresh, faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Badge, IconButton } from "@mui/material";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR/";
import stylesAnaliseVistoria from "./SolicitacaoVistoriaAnalise.module.css";

const StatusSituacaoAnalise = ({ value }) => {
    switch (value) {
        case 1:
            return (
                <Tooltip title="Aguardando análise" placement="right">
                    <div className={stylesAnaliseVistoria.statusTexto}>
                        <div className={stylesAnaliseVistoria.statusAguardandoAnalise}>
                            <FontAwesomeIcon icon={faRefresh} />
                        </div>
                        Aguardando análise
                    </div>
                </Tooltip>
            );
        case 2:
            return (
                <Tooltip title="Finalizada" placement="right">
                    <div className={stylesAnaliseVistoria.statusTexto}>
                        <div className={stylesAnaliseVistoria.statusFinalizada}>
                            <FontAwesomeIcon icon={faCheck} />
                        </div>
                        Finalizada
                    </div>
                </Tooltip>
            );
        default:
            return (
                <Tooltip title="Reprovada" placement="right">
                    <div className={stylesAnaliseVistoria.statusTexto}>
                        <div className={stylesAnaliseVistoria.statusReprovada}>
                            <FontAwesomeIcon icon={faClose} />
                        </div>
                        Reprovada
                    </div>
                </Tooltip>
            );
    }
};

const columnsSolicitacaoVistoriaAnalise = (onOpenAnexos, parametros) => {
    const exibirAnexos = parametros?.Content?.DisponibilizarAnexosCod;

    const colunaAnexos = {
        field: 'Anexos',
        headerName: '',
        width: 80,
        align: 'center',
        headerAlign: 'center',
        renderHeader: () => (
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                }}
            >
                <FontAwesomeIcon icon={faImage} size="lg" color="#8166F5" />
            </div>
        ),
        renderCell: (params) => {
            const qtde = params.row.QtdeAnexos;
            const codigo = params.row.CodigoSolicitacaoCod;

            return (
                <Tooltip title="Ver anexos">
                    <IconButton onClick={() => onOpenAnexos(codigo)}>
                        <Badge
                            badgeContent={qtde > 0 ? qtde : null}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left'
                            }}
                            sx={{
                                '& .MuiBadge-badge': {
                                    backgroundColor: '#DCD3FF',
                                    color: '#000',
                                    border: '1px solid #8166F5',
                                    fontWeight: 'bold'
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faImage} color="#8166F5" />
                        </Badge>
                    </IconButton>
                </Tooltip>
            );
        }
    };

    const outrasColunas = [
        {
            field: 'Situacao',
            headerName: 'Situação',
            renderCell: (params) => (
                <StatusSituacaoAnalise value={params.value} />
            ),
            flex: 0.5,
        },
        {
            field: 'DataApresentacao',
            headerName: 'Data de apresentação',
            flex: 0.5,
            renderCell: (params) => {
                let data = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());
                return format(data, 'dd/MM/yyyy', { locale: ptBR });
            }
        },
        {
            field: 'DataAnalise',
            headerName: 'Data de análise',
            flex: 0.5,
            renderCell: (params) => {
                let data = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());
                return format(data, 'dd/MM/yyyy', { locale: ptBR });
            }
        },
        {
            field: 'ParecerAnalise',
            headerName: 'Parecer da análise',
            flex: 3.5
        }
    ];

    return exibirAnexos ? [colunaAnexos, ...outrasColunas] : outrasColunas;
};

export { columnsSolicitacaoVistoriaAnalise };